import { useDeckStore } from '../../stores/deck-store.js';
import { SideboardCardRow } from './SideboardCardRow.js';

export function SideboardTab() {
  const sideboard = useDeckStore((s) => s.sideboard);

  if (sideboard.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center flex-1 gap-2 text-center px-6 py-10">
        <p className="text-gray-600 text-sm">No cards in the sideboard.</p>
        <p className="text-gray-700 text-xs">
          Add cards from search results to evaluate them here.
        </p>
      </div>
    );
  }

  return (
    <div className="flex flex-col">
      {sideboard.map((entry) => (
        <SideboardCardRow key={entry.card.oracleId} card={entry.card} />
      ))}
    </div>
  );
}
